
var  resultJson = {
	"workers": {
		"low": {
			"label": "Niski",
			"description": "Uzyskany wynik świadczy o braku zagrożenia występowania u Pani/Pana syndromu wypalenia zawodowego. Syndrom wypalenia zawodowego występuje często u osób, które zawodowo zajmują się pomaganiem, w tym mających kontakt z dziećmi chorymi, niepełnosprawnymi oraz z zaburzeniami rozwojowymi. Uzyskany wynik wskazuje, że albo z uwagi na uzyskane wsparcie informacyjne i/lub emocjonalne albo też z uwagi na umiejętność radzenia sobie z sytuacją trudną nie jest Pani/Pan obecnie zagrożona/zagrożony występowaniem syndromu wypalenia zawodowego. Należy jednak pamiętać, że narzędzie diagnostyczne, którym właśnie Pani/Pan się posłużyła/posłużył ma jedynie charakter przesiewowy, a uzyskane wyniki mają jedynie wartość informacyjną i nie mogą zastąpić indywidualnej diagnozy psychologicznej ani diagnozy lekarskiej. "
		},
		"medium": {
			"label": "Średni",
			"description": "Uzyskany wynik świadczy o umiarkowanym zagrożeniu występowania u Pani/Pana syndromu wypalenia zawodowego. Syndrom wypalenia zawodowego występuje często u osób, które zawodowo zajmują się pomaganiem, w tym mających kontakt z dziećmi chorymi, niepełnosprawnymi oraz z zaburzeniami rozwojowymi. Uzyskany wynik wskazuje, że albo z uwagi na uzyskane wsparcie informacyjne i/lub emocjonalne albo też z uwagi na umiejętność radzenia sobie z sytuacją trudną jest Pani/Pan obecnie w umiarkowanym stopniu zagrożona/zagrożony występowaniem syndromu wypalenia zawodowego. W związku z uzyskanym wynikiem warto rozważyć kontakt z psychologiem/psychoterapeutą w celu określenia poziomu zagrożenia na drodze diagnozy specjalistycznej. Należy bowiem pamiętać, że narzędzie diagnostyczne, którym właśnie Pani/Pan się posłużyła/posłużył ma jedynie charakter przesiewowy, a uzyskane wyniki mają jedynie wartość informacyjną i nie mogą zastąpić indywidualnej diagnozy psychologicznej ani diagnozy lekarskiej. "
		},
		"high": {
			"label": "Wysoki",
			"description": "Uzyskany wynik świadczy o wysokim zagrożeniu występowania u Pani/Pana syndromu wypalenia zawodowego. Syndrom wypalenia zawodowego występuje często u osób, które zawodowo zajmują się pomaganiem, w tym mających kontakt z dziećmi chorymi, niepełnosprawnymi oraz z zaburzeniami rozwojowymi. Uzyskany wynik wskazuje, że jest Pani/Pan obecnie w wysokim stopniu zagrożona/zagrożony występowaniem syndromu wypalenia zawodowego. W związku z uzyskanym wynikiem warto rozważyć kontakt z psychologiem/psychoterapeutą w celu określenia poziomu zagrożenia na drodze diagnozy specjalistycznej i ewentualne podjęcie pracy terapeutycznej. Należy bowiem pamiętać, że narzędzie diagnostyczne, którym właśnie Pani/Pan się posłużyła/posłużył ma jedynie charakter przesiewowy, a uzyskane wyniki mają jedynie wartość informacyjną i nie mogą zastąpić indywidualnej diagnozy psychologicznej ani diagnozy lekarskiej. "
		}
	},
	"family": {
		"low": {
			"label": "Niski",
			"description": "Uzyskany wynik świadczy o braku zagrożenia występowania u Pani/Pana syndromu wypalenia sił. Syndrom wypalenia sił występuje często u rodziców dzieci chorych, niepełnosprawnych oraz z zaburzeniami rozwojowymi. Uzyskany wynik wskazuje, że albo z uwagi na uzyskane wsparcie informacyjne i/lub emocjonalne albo też z uwagi na umiejętność radzenia sobie z sytuacją trudną nie jest Pani/Pan obecnie zagrożona/zagrożony występowaniem syndromu wypalenia sił. Należy jednak pamiętać, że narzędzie diagnostyczne, którym właśnie Pani/Pan się posłużyła/posłużył ma jedynie charakter przesiewowy, a uzyskane wyniki mają jedynie wartość informacyjną i nie mogą zastąpić indywidualnej diagnozy psychologicznej ani diagnozy lekarskiej. "
		},
		"medium": {
			"label": "Średni",
			"description": "Uzyskany wynik świadczy o umiarkowanym zagrożeniu występowania u Pani/Pana syndromu wypalenia sił. Syndrom wypalenia sił występuje często u rodziców dzieci chorych, niepełnosprawnych oraz z zaburzeniami rozwojowymi. Uzyskany wynik wskazuje, że albo z uwagi na uzyskane wsparcie informacyjne i/lub emocjonalne albo też z uwagi na umiejętność radzenia sobie z sytuacją trudną jest Pani/Pan obecnie w umiarkowanym stopniu zagrożona/zagrożony występowaniem syndromu wypalenia sił. W związku z uzyskanym wynikiem warto rozważyć kontakt z psychologiem/psychoterapeutą w celu określenia poziomu zagrożenia na drodze diagnozy specjalistycznej. Należy bowiem pamiętać, że narzędzie diagnostyczne, którym właśnie Pani/Pan się posłużyła/posłużył ma jedynie charakter przesiewowy, a uzyskane wyniki mają jedynie wartość informacyjną i nie mogą zastąpić indywidualnej diagnozy psychologicznej ani diagnozy lekarskiej. "
		},
		"high": {
			"label": "Wysoki",
			"description": "Uzyskany wynik świadczy o wysokim zagrożeniu występowania u Pani/Pana syndromu wypalenia sił. Syndrom wypalenia sił występuje często u rodziców dzieci chorych, niepełnosprawnych oraz z zaburzeniami rozwojowymi. Uzyskany wynik wskazuje, że jest Pani/Pan obecnie w wysokim stopniu zagrożona/zagrożony występowaniem syndromu wypalenia sił. W związku z uzyskanym wynikiem warto rozważyć kontakt z psychologiem/psychoterapeutą w celu określenia poziomu zagrożenia na drodze diagnozy specjalistycznej i ewentualne podjęcie pracy terapeutycznej. Należy bowiem pamiętać, że narzędzie diagnostyczne, którym właśnie Pani/Pan się posłużyła/posłużył ma jedynie charakter przesiewowy, a uzyskane wyniki mają jedynie wartość informacyjną i nie mogą zastąpić indywidualnej diagnozy psychologicznej ani diagnozy lekarskiej. "
		}
	}
}

var json = {
    "locale": "pl",
    "showQuestionNumbers": "off",
    "pages": [
        {
			
            "name": "Dane personalne",
            "elements": [
                {
                    "type": "radiogroup",
                    "name": "RegisterData",
                    "startWithNewLine": false,
                    "title": {
                        "pl": "Czy zarejestrować badanie?"
                    },
                    "choices": [
                        {
                            "value": "1",
                            "text": {
                                "pl": "Tak"
                            }
                        },
                        {
                            "value": "0",
                            "text": {
                                "pl": "Nie, wykonaj anonimowe badanie"
                            }
                        }
                    ]
                },
				 {
                    "type": "radiogroup",
                    "name": "sendEmail",
                    "startWithNewLine": true,
                    "title": {
                        "pl": "Wyślij wynik badań na Twoją skrzynkę e-mail. Twój adres email nie będzie nigdzie zapisany ani wykorzystany w żadnym innym celu niż przesłania wyniku (Po zakończeniu testu wynik również będzie widoczny)."
                    },
                    "choices": [
                         {
                            "value": "1",
                            "text": {
                                "pl": "Tak"
                            }
                        },
                        {
                            "value": "0",
                            "text": {
                                "pl": "Nie"
                            }
                        }
                    ]
                },
                {
                    "type": "text",
                    "name": "Nickname",
                    "visible": false,
                    "visibleIf": "{sendEmail} = 1",
                    "title": {
                        "pl": "Podaj pseudonim"
                    },
                    "isRequired": true
                },
                {
                    "type": "text",
                    "name": "Email",
                    "visible": false,
                    "visibleIf": "{sendEmail} = 1",
                    "title": {
                        "pl": "Podaj adres email"
                    },
                    "isRequired": true,
                    "inputType": "email",
					"validators": [{"type": "email"}]
                }
            ],
            "title": {
                "default": "default_",
                "pl": "Kwestionariusz do określenia funkcjonowania emocjonalnego oraz zagrożenia wystąpieniem syndromu wypalenia zawodowego u osób pracujących z dziećmi ze spektrum autyzmu"
            }
        }
        ,{ 
            "title": "Szanowni Państwo. Prosimy o zaznaczenie odpowiedzi, która najtrafniej charakteryzuje Państwa stosunek do postawionych pytań. ",
            "elements": [
                {
                    "type": "radiogroup", "name": "q1", "title": {"pl": "Czy pracę z dziećmi ze spektrum autyzmu traktuje Pan/Pani jako pewnego rodzaju misję?"},
                    "isRequired": true,
                    "choices": [
                        {
                            "value": "0", "text": {"pl": "Zadecydowanie Tak"}
                        },
                        {
                            "value": "1", "text": {"pl": "Tak"}
                        },
                        {
                            "value": "2", "text": {"pl": "Nie"}
                        },
                        {
                            "value": "3", "text": {"pl": "Zdecydowanie Nie"}
                        }
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                    "type": "radiogroup", "name": "q2", "isRequired": true, "title":
                        {"pl": "Czy praca z dziećmi ze spektrum autyzmu przynosi Panu/Pani satysfakcję?"},
                    "choices": [
                        {"value": "0", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "1", "text": {"pl": "Tak"}},
                        {"value": "2", "text": {"pl": "Nie"}},
                        {"value": "3", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                  {
                    "type": "radiogroup", "name": "q3", "isRequired": true, "title":
                        {"pl": "Czy zdarza się Panu/Pani wątpić w wartość wykonywanej przez Pana/Panią pracy?"},
                    "choices": [
                        {"value": "3", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "2", "text": {"pl": "Tak"}},
                        {"value": "1", "text": {"pl": "Nie"}},
                        {"value": "0", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                  {
                    "type": "radiogroup", "name": "q4", "isRequired": true, "title":
                        {"pl": "Czy wykonywana praca jest dla Pana/Pani obciążająca emocjonalnie?"},
                    "choices": [
                        {"value": "3", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "2", "text": {"pl": "Tak"}},
                        {"value": "1", "text": {"pl": "Nie"}},
                        {"value": "0", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                  {
                    "type": "radiogroup", "name": "q5", "isRequired": true, "title":
                        {"pl": "Czy obciążenia wynikające z pracy wpływają na inne sfery Pana/Pani życia?"},
                    "choices": [
                        {"value": "3", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "2", "text": {"pl": "Tak"}},
                        {"value": "1", "text": {"pl": "Nie"}},
                        {"value": "0", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                 {
                    "type": "radiogroup", "name": "q6", "isRequired": true, "title":
                        {"pl": "Czy myśli Pan/Pani o swoich uczniach/pacjentach poza godzinami pracy?"},
                    "choices": [
                        {"value": "3", "text": {"pl": "Bardzo często"}},
                        {"value": "2", "text": {"pl": "Często"}},
                        {"value": "1", "text": {"pl": "Rzadko"}},
                        {"value": "0", "text": {"pl": "Nigdy"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                    "type": "radiogroup", "name": "q7", "isRequired": true, "title":
                        {"pl": "Czy nieprzewidywalność zachowań dzieci ze spektrum autyzmu jest dla Pana/Pani obciążająca?"},
                    "choices": [
                        {"value": "3", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "2", "text": {"pl": "Tak"}},
                        {"value": "1", "text": {"pl": "Nie"}},
                        {"value": "0", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                    "type": "radiogroup", "name": "q8", "isRequired": true, "title":
                        {"pl": "Czy radzi sobie Pan/Pani z zachowaniami agresywnymi dzieci ze spektrum autyzmu?"},
                    "choices": [
                        {"value": "0", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "1", "text": {"pl": "Tak"}},
                        {"value": "2", "text": {"pl": "Nie"}},
                        {"value": "3", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                    "type": "radiogroup", "name": "q9", "isRequired": true, "title":
                        {"pl": "Czy łatwo jest zdobyć wiarygodne informacje na temat specyfiki zaburzeń ze spektrum autyzmu?"},
                    "choices": [
                        {"value": "0", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "1", "text": {"pl": "Tak"}},
                        {"value": "2", "text": {"pl": "Nie"}},
                        {"value": "3", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                    "type": "radiogroup", "name": "q10", "isRequired": true, "title":
                        {"pl": "Czy trudność w nawiązaniu relacji z uczniem/pacjentem ze spektrum autyzmu jest dla Pana/Pani frustrująca?"},
                    "choices": [
                        {"value": "3", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "2", "text": {"pl": "Tak"}},
                        {"value": "1", "text": {"pl": "Nie"}},
                        {"value": "0", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                    "type": "radiogroup", "name": "q11", "isRequired": true, "title":
                        {"pl": "Czy współpraca z rodzicami dzieci ze spektrum autyzmu jest dla Pana/Pani obciążająca?"},
                    "choices": [
                        {"value": "3", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "2", "text": {"pl": "Tak"}},
                        {"value": "1", "text": {"pl": "Nie"}},
                        {"value": "0", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                    "type": "radiogroup", "name": "q12", "isRequired": true, "title":
                        {"pl": "Czy korzysta Pan/Pani z grup wsparcia formalnych bądź nieformalnych?"},
                    "choices": [
                        {"value": "0", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "1", "text": {"pl": "Tak"}},
                        {"value": "2", "text": {"pl": "Nie"}},
                        {"value": "3", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                    "type": "radiogroup", "name": "q13", "isRequired": true, "title":
                        {"pl": "Czy korzysta Pan/Pani z superwizji?"},
                    "choices": [
                        {"value": "0", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "1", "text": {"pl": "Tak"}},
                        {"value": "2", "text": {"pl": "Nie"}},
                        {"value": "3", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                    "type": "radiogroup", "name": "q14", "isRequired": true, "title":
                        {"pl": "Czy otrzymuje Pan/Pani wystarczające wsparcie ze strony współpracowników w zakresie obciążeń wynikających ze specyfiki Pana/Pani pracy?"},
                    "choices": [
                        {"value": "0", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "1", "text": {"pl": "Tak"}},
                        {"value": "2", "text": {"pl": "Nie"}},
                        {"value": "3", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                 {
                    "type": "radiogroup", "name": "q15", "isRequired": true, "title":
                        {"pl": "Czy stawia sobie Pan/Pani wysokie wymagania w pracy zawodowej?"},
                    "choices": [
                        {"value": "3", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "2", "text": {"pl": "Tak"}},
                        {"value": "1", "text": {"pl": "Nie"}},
                        {"value": "0", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                    "type": "radiogroup", "name": "q16", "isRequired": true, "title":
                        {"pl": "Czy uważa Pan/Pani, że sukces zawodowy zależy od Pana/Pani starań?"},
                    "choices": [
                        {"value": "0", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "1", "text": {"pl": "Tak"}},
                        {"value": "2", "text": {"pl": "Nie"}},
                        {"value": "3", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                    "type": "radiogroup", "name": "q17", "isRequired": true, "title":
                        {"pl": "Czy ma Pan/Pani trudności z organizacją pracy?"},
                    "choices": [
                        {"value": "3", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "2", "text": {"pl": "Tak"}},
                        {"value": "1", "text": {"pl": "Nie"}},
                        {"value": "0", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                    "type": "radiogroup", "name": "q18", "isRequired": true, "title":
                        {"pl": "Często zdarza się Panu/Pani odczuwać niechęć do swoich uczniów/pacjentów ze spektrum autyzmu?"},
                    "choices": [
                        {"value": "3", "text": {"pl": "Bardzo często"}},
                        {"value": "2", "text": {"pl": "Często"}},
                        {"value": "1", "text": {"pl": "Rzadko"}},
                        {"value": "0", "text": {"pl": "Nigdy"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                 {
                    "type": "radiogroup", "name": "q19", "isRequired": true, "title":
                        {"pl": "Czy czuje Pan/Pani, że Pana/Pani kompetencje zawodowe są wystarczające?"},
                    "choices": [
                        {"value": "0", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "1", "text": {"pl": "Tak"}},
                        {"value": "2", "text": {"pl": "Nie"}},
                        {"value": "3", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                    "type": "radiogroup", "name": "q20", "isRequired": true, "title":
                        {"pl": " Czy cierpi Pan/Pani na zaburzenia snu?"},
                    "choices": [
                        {"value": "3", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "2", "text": {"pl": "Tak"}},
                        {"value": "1", "text": {"pl": "Nie"}},
                        {"value": "0", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                } 
			]
		},
		{ 
            "title": "",
            "elements": [
               {
                    "type": "radiogroup", "name": "q21", "isRequired": true, "title":
                        {"pl": "Czy ma Pan/Pani trudności ze zrelaksowaniem się/odpoczynkiem?"},
                    "choices": [
                        {"value": "3", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "2", "text": {"pl": "Tak"}},
                        {"value": "1", "text": {"pl": "Nie"}},
                        {"value": "0", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                } 
			]
		},
		{ 
            "title": "",
            "elements": [
                 {
                    "type": "radiogroup", "name": "q22", "isRequired": true, "title":
                        {"pl": "Czy ma Pan/Pani trudności z doprowadzaniem rozpoczętych działań zawodowych do końca?"},
                    "choices": [
                        {"value": "3", "text": {"pl": "Bardzo często"}},
                        {"value": "2", "text": {"pl": "Często"}},
                        {"value": "1", "text": {"pl": "Rzadko"}},
                        {"value": "0", "text": {"pl": "Nigdy"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
               {
                    "type": "radiogroup", "name": "q23", "isRequired": true, "title":
                        {"pl": "Czy rozumie Pan/Pani zachowania dzieci ze spektrum autyzmu?"},
                    "choices": [
                        {"value": "0", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "1", "text": {"pl": "Tak"}},
                        {"value": "2", "text": {"pl": "Nie"}},
                        {"value": "3", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                } 
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                    "type": "radiogroup", "name": "q24", "isRequired": true, "title":
                        {"pl": "Czy odczuwa Pan/Pani smutek lub złość, gdy nie osiąga Pan/Pani zamierzonych celów zawodowych?"},
                    "choices": [
                        {"value": "3", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "2", "text": {"pl": "Tak"}},
                        {"value": "1", "text": {"pl": "Nie"}},
                        {"value": "0", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
				"type": "radiogroup", "name": "q2", "isRequired": true, "title":
                        {"pl": "Czy praca z dziećmi ze spektrum autyzmu przynosi Panu/Pani satysfakcję?"},
						"choices": [
							{"value": "0", "text": {"pl": "Zadecydowanie Tak"}},
							{"value": "1", "text": {"pl": "Tak"}},
							{"value": "2", "text": {"pl": "Nie"}},
							{"value": "3", "text": {"pl": "Zdecydowanie Nie"}}
						]
                }
			]
		}		 
    ],
    "sendResultOnPageNext": true,
    "showProgressBar": "top",
    "startSurveyText": {
        "pl": "start"
    },
    "pagePrevText": {
        "pl": "poprzedni"
    },
    "pageNextText": {
        "pl": "dalej"
    },
    "completeText": {
        "pl": "koniec"
    }
}



var json2 = {
    "locale": "pl",
    "showQuestionNumbers": "off",
    "pages": [
       {
            "name": "Dane personalne",
         "elements": [
                {
                    "type": "radiogroup",
                    "name": "RegisterData",
                    "startWithNewLine": false,
                    "title": {
                        "pl": "Czy zarejestrować badanie?"
                    },
                    "choices": [
                        {
                            "value": "1",
                            "text": {
                                "pl": "Tak"
                            }
                        },
                        {
                            "value": "0",
                            "text": {
                                "pl": "Nie, wykonaj anonimowe badanie"
                            }
                        }
                    ]
                },
				 {
                    "type": "radiogroup",
                    "name": "sendEmail",
                    "startWithNewLine": true,
                    "title": {
                      "pl": "Wyślij wynik badań na Twoją skrzynkę e-mail. Twój adres email nie będzie nigdzie zapisany ani wykorzystany w żadnym innym celu niż przesłania wyniku (Po zakończeniu testu wynik również będzie widoczny)."
                    },
                    "choices": [
                         {
                            "value": "1",
                            "text": {
                                "pl": "Tak"
                            }
                        },
                        {
                            "value": "0",
                            "text": {
                                "pl": "Nie"
                            }
                        }
                    ]
                },
                {
                    "type": "text",
                    "name": "Nickname",
                    "visible": false,
                    "visibleIf": "{sendEmail} = 1",
                    "title": {
                        "pl": "Podaj pseudonim"
                    },
                    "isRequired": true
                },
                {
                    "type": "text",
                    "name": "Email",
                    "visible": false,
                    "visibleIf": "{sendEmail} = 1",
                    "title": {
                        "pl": "Podaj adres email"
                    },
                    "isRequired": true,
                    "inputType": "email",
					"validators": [{"type": "email"}]
                }
            ],
            "title": {
                "default": "default_",
                "pl": "Kwestionariusz do określenia funkcjonowania emocjonalnego oraz zagrożenia wystąpienia syndromu wypalenia sił u rodziców dzieci ze spektrum autyzmu"
            }
        },
        { 
            "title": "Szanowni Państwo. Prosimy o zaznaczenie odpowiedzi, która najtrafniej charakteryzuje Państwa stosunek do postawionych pytań. ",
            "elements": [
                {
                    "type": "radiogroup", "name": "q1", "title": {"pl": "Czy czuje Pan/Pani zrozumienie społeczne w związku z posiadaniem dziecka ze spektrum autyzmu?"},
                    "isRequired": true,
                    "choices": [
                        {
                            "value": "0", "text": {"pl": "Zadecydowanie Tak"}
                        },
                        {
                            "value": "1", "text": {"pl": "Tak"}
                        },
                        {
                            "value": "2", "text": {"pl": "Nie"}
                        },
                        {
                            "value": "3", "text": {"pl": "Zdecydowanie Nie"}
                        }
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                    
                    "type": "radiogroup", "name": "q2", "isRequired": true, "title":
                        {"pl": "Czy czuje się Pan/Pani negatywnie oceniany/oceniana lub stygmatyzowany/stygmatyzowana przez otoczenie w związku z posiadaniem dziecka ze spektrum autyzmu?"},
                    "choices": [
                        {"value": "3", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "2", "text": {"pl": "Tak"}},
                        {"value": "1", "text": {"pl": "Nie"}},
                        {"value": "0", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                    "type": "radiogroup", "name": "q3", "isRequired": true, "title":
                        {"pl": "Czy ma Pan/Pani poczucie przeciążenia wynikające z opieki nad dzieckiem ze spektrum autyzmu?"},
                    "choices": [
                        {"value": "3", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "2", "text": {"pl": "Tak"}},
                        {"value": "1", "text": {"pl": "Nie"}},
                        {"value": "0", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                    "type": "radiogroup", "name": "q4", "isRequired": true, "title":
                        {"pl": "Czy obawia się Pan/Pani o przyszłość swojego dziecka?"},
                    "choices": [
                        {"value": "3", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "2", "text": {"pl": "Tak"}},
                        {"value": "1", "text": {"pl": "Nie"}},
                        {"value": "0", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                    "type": "radiogroup", "name": "q5", "isRequired": true, "title":
                        {"pl": "Czy często czuje się Pan/Pani zmęczony/zmęczona fizycznie?"},
                    "choices": [
                        {"value": "3", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "2", "text": {"pl": "Tak"}},
                        {"value": "1", "text": {"pl": "Nie"}},
                        {"value": "0", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                    "type": "radiogroup", "name": "q6", "isRequired": true, "title":
                        {"pl": "Czy sypia Pan/Pani regularnie i wystarczająco dużo?"},
                    "choices": [
                        {"value": "0", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "1", "text": {"pl": "Tak"}},
                        {"value": "2", "text": {"pl": "Nie"}},
                        {"value": "3", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                    "type": "radiogroup", "name": "q7", "isRequired": true, "title":
                        {"pl": "Czy miewa Pan/Pani obniżony nastrój?"},
                    "choices": [
                        {"value": "3", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "2", "text": {"pl": "Tak"}},
                        {"value": "1", "text": {"pl": "Nie"}},
                        {"value": "0", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                    "type": "radiogroup", "name": "q8", "isRequired": true, "title":
                        {"pl": "Czy Pana/Pani kontakty towarzyskie są satysfakcjonujące?"},
                    "choices": [
                        {"value": "0", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "1", "text": {"pl": "Tak"}},
                        {"value": "2", "text": {"pl": "Nie"}},
                        {"value": "3", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                    "type": "radiogroup", "name": "q9", "isRequired": true, "title":
                        {"pl": "Czy odczuwa/zaobserwował/zaobserwowała Pan/Pani bóle głowy, bóle mięśni, utratę włosów, choroby skóry lub objawy skórne np. wysypki?"},
                    "choices": [
                      {"value": "3", "text": {"pl": "Bardzo często"}},
                        {"value": "2", "text": {"pl": "Często"}},
                        {"value": "1", "text": {"pl": "Rzadko"}},
                        {"value": "0", "text": {"pl": "Nigdy"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                     "type": "radiogroup", "name": "q10", "isRequired": true, "title":
                        {"pl": "Czy korzysta Pan/Pani z grup wsparcia formalnych bądź nieformalnych?"},
                    "choices": [
                        {"value": "0", "text": {"pl": "Bardzo często"}},
                        {"value": "1", "text": {"pl": "Często"}},
                        {"value": "2", "text": {"pl": "Rzadko"}},
                        {"value": "3", "text": {"pl": "Nigdy"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                     "type": "radiogroup", "name": "q11", "isRequired": true, "title":
                        {"pl": "Czy miewa Pan/Pani poczucie bezsensu podejmowanych działań w kwestii pracy ze swoim dzieckiem ze spektrum autyzmu?"},
                    "choices": [
                        {"value": "3", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "2", "text": {"pl": "Tak"}},
                        {"value": "1", "text": {"pl": "Nie"}},
                        {"value": "0", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                    "type": "radiogroup", "name": "q12", "isRequired": true, "title":
                        {"pl": "Czy miewa Pan/Pani poczucie izolacji i niezrozumienia ze strony otoczenia?"},
                    "choices": [
						{"value": "3", "text": {"pl": "Bardzo często"}},
                        {"value": "2", "text": {"pl": "Często"}},
                        {"value": "1", "text": {"pl": "Rzadko"}},
                        {"value": "0", "text": {"pl": "Nigdy"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                     "type": "radiogroup", "name": "q13", "isRequired": true, "title":
                        {"pl": "Czy łatwo jest zdobyć wiarygodne informacje na temat postępowania z Pana/Pani dzieckiem ze spektrum autyzmu?"},
                    "choices": [
                        {"value": "0", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "1", "text": {"pl": "Tak"}},
                        {"value": "2", "text": {"pl": "Nie"}},
                        {"value": "3", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                   "type": "radiogroup", "name": "q14", "isRequired": true, "title":
                        {"pl": "Czy posiadanie dziecka zespektrum autyzmu wpłynęło negatywnie na Pana/Pani aktywność zawodową?"},
                    "choices": [
                        {"value": "3", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "2", "text": {"pl": "Tak"}},
                        {"value": "1", "text": {"pl": "Nie"}},
                        {"value": "0", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                     "type": "radiogroup", "name": "q15", "isRequired": true, "title":
                        {"pl": "Czy otrzymuje Pan/Pani wsparcie ze strony otoczenia w związku z posiadaniem dziecka ze spektrum autyzmu?"},
                    "choices": [
                        {"value": "0", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "1", "text": {"pl": "Tak"}},
                        {"value": "2", "text": {"pl": "Nie"}},
                        {"value": "3", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                     "type": "radiogroup", "name": "q16", "isRequired": true, "title":
                        {"pl": "Czy otrzymuje Pan/Pani wsparcie ze strony męża/żony/partnerki/partnera?"},
                    "choices": [
                        {"value": "0", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "1", "text": {"pl": "Tak"}},
                        {"value": "2", "text": {"pl": "Nie"}},
                        {"value": "3", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                   "type": "radiogroup", "name": "q17", "isRequired": true, "title":
                        {"pl": "Czy otrzymuje Pan/Pani wsparcie ze strony swojej rodziny?"},
                    "choices": [
                        {"value": "0", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "1", "text": {"pl": "Tak"}},
                        {"value": "2", "text": {"pl": "Nie"}},
                        {"value": "3", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                    "type": "radiogroup", "name": "q18", "isRequired": true, "title":
                        {"pl": "Czy otrzymuje Pan/Pani wsparcie ze strony przyjaciół/znajomych?"},
                    "choices": [
                        {"value": "0", "text": {"pl": "Bardzo często"}},
                        {"value": "1", "text": {"pl": "Często"}},
                        {"value": "2", "text": {"pl": "Rzadko"}},
                        {"value": "3", "text": {"pl": "Nigdy"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                   "type": "radiogroup", "name": "q19", "isRequired": true, "title":
                        {"pl": "Czy ma Pan/Pani trudności z uzyskaniem stanu odprężenia?"},
                    "choices": [
                        {"value": "3", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "2", "text": {"pl": "Tak"}},
                        {"value": "1", "text": {"pl": "Nie"}},
                        {"value": "0", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                   "type": "radiogroup", "name": "q20", "isRequired": true, "title":
                        {"pl": "Czy odczuwa Pan/Pani smutek lub złość w sytuacji, kiedy nie osiąga Pan/Pani zamierzonych celów?"},
                    "choices": [
                        {"value": "3", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "2", "text": {"pl": "Tak"}},
                        {"value": "1", "text": {"pl": "Nie"}},
                        {"value": "0", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                   "type": "radiogroup", "name": "q21", "isRequired": true, "title":
                        {"pl": "Czy czuje Pan/Pani spadek energii?"},
                    "choices": [
                        {"value": "3", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "2", "text": {"pl": "Tak"}},
                        {"value": "1", "text": {"pl": "Nie"}},
                        {"value": "0", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                   "type": "radiogroup", "name": "q22", "isRequired": true, "title":
                        {"pl": "Czy czuje się Pan/Pani nerwowy/nerwowa bez wyraźnego powodu?"},
                    "choices": [
                        {"value": "3", "text": {"pl": "Bardzo często"}},
                        {"value": "2", "text": {"pl": "Często"}},
                        {"value": "1", "text": {"pl": "Rzadko"}},
                        {"value": "0", "text": {"pl": "Nigdy"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                    "type": "radiogroup", "name": "q23", "isRequired": true, "title":
                        {"pl": "Czy czuje Pan/Pani, że otoczenie wymaga od Pana/Pani zbyt wiele?"},
                    "choices": [
                        {"value": "3", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "2", "text": {"pl": "Tak"}},
                        {"value": "1", "text": {"pl": "Nie"}},
                        {"value": "0", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		},
		{ 
            "title": "",
            "elements": [
                {
                    "type": "radiogroup", "name": "q24", "isRequired": true, "title":
                        {"pl": "Czy jeśli by Pan/Pani mógł/mogła to wszystko bądź prawie wszystko zmieniłby/zmieniłaby Pan/Pani w swoim życiu?"},
                    "choices": [
                        {"value": "3", "text": {"pl": "Zadecydowanie Tak"}},
                        {"value": "2", "text": {"pl": "Tak"}},
                        {"value": "1", "text": {"pl": "Nie"}},
                        {"value": "0", "text": {"pl": "Zdecydowanie Nie"}}
                    ]
                }
			]
		} 
    ],
    "sendResultOnPageNext": true,
    "showProgressBar": "top",
    "startSurveyText": {
        "pl": "start"
    },
    "pagePrevText": {
        "pl": "poprzedni"
    },
    "pageNextText": {
        "pl": "dalej"
    },
    "completeText": {
        "pl": "koniec"
    }
}




export default class FormMock {
    static get(query, id) {
        if (query.length > 0) {
            // console.log(query)
        }
        return FormMock.getForm(id)
    }
    static getForm(id) {
        if (id == "pracownicy")
            return {'data': {
                    'form': json
                }
            }
        return {'data': {
                'form': json2
            }
        }

    }

	
    static getResult(pointSum,id) {
		var resultSetName = "family"; 
		if(id=="pracownicy"){
			resultSetName = "workers";
		}
		var resultSet = resultJson[resultSetName]; 
         
        if (pointSum <= 24)
            return {'data': {
                    'result': resultJson[resultSetName]["low"]
                }
            };

        if (pointSum <= 48)
            return {'data': {
                   'result': resultJson[resultSetName]["medium"]
                }
            };

        if (pointSum <= 72)
            return {'data': {
                  'result': resultJson[resultSetName]["high"]
                }
            };
        else
            return {'data': {
                    'result': {'label': "error"}
                }
            };

    }
}

/*
 * {
 "type": "imagepicker",
 "name": "img_choice",
 "title": {
 "pl": "Wybierz zdjęcie"
 },
 "choices": [
 {
 "value": "1",
 "imageLink": "/static/img/img1.jpg"
 },
 {
 "value": "2",
 "imageLink": "/static/img/img2.jpg"
 },
 {
 "value": "3",
 "imageLink": "/static/img/img3.jpg"
 }
 ]
 },
 {
 "type": "imagepicker",
 "name": "question3",
 "choices": [
 {
 "value": "lion",
 "imageLink": "https://surveyjs.io/Content/Images/examples/image-picker/lion.jpg"
 },
 {
 "value": "giraffe",
 "imageLink": "https://surveyjs.io/Content/Images/examples/image-picker/giraffe.jpg"
 },
 {
 "value": "panda",
 "imageLink": "https://surveyjs.io/Content/Images/examples/image-picker/panda.jpg"
 },
 {
 "value": "camel",
 "imageLink": "https://surveyjs.io/Content/Images/examples/image-picker/camel.jpg"
 }
 ]
 }
 */


// WEBPACK FOOTER //
// ./src/static/api/mock/FormMock.js